export enum Platform {
	DESKTOP,
	MOBILE,
}
